<script>
    import {onMount} from 'svelte';
    import {scale} from 'svelte/transition';
    import {cubicInOut} from 'svelte/easing';

    import Modal from 'flowbite/lib/esm/components/modal/index';

    import {mapStore} from '@js/stores/mapStore';

    import PlanForm from '@js/components/plan/form/PlanForm.svelte';

    let {
        isModalOpen = $bindable(false),
        id = 'plan-modal',
        planPoiCoordinates,
        planPoi,
        planRide,
        onDelete,
        onCreated
    } = $props();

    let _modalElement;

    const _initializeModal = () => {
        if (_modalElement) {
            return;
        }

        const targetElement = document.getElementById(id);
        if (!targetElement) {
            return;
        }

        const modalOptions = {
            placement: 'center-center',
            backdrop: 'dynamic',
            backdropClasses: 'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-modal-background',
            closable: true,
            // onShow: () => {
            // },
            onHide: () => {
                isModalOpen = false;
            }
        };

        _modalElement = new Modal(targetElement, modalOptions);
    };

    const _handleModalClose = () => {
        isModalOpen = false;
    };

    onMount(() => {
        _initializeModal();

        return () => {
            if (mapStore.map) {
                mapStore.map.destroy();
                mapStore.map = null;
            }
        };
    });

    $effect(() => {
        if (!_modalElement) {
            return;
        }

        if (isModalOpen) {
            _modalElement.show();
        } else {
            _modalElement.hide();
        }
    });
</script>

<div id={id}
     tabindex="-1"
     class="hidden fixed top-0 left-0 right-0 w-full h-[calc(100%-1rem)] max-h-full p-1 md:p-4 overflow-x-hidden overflow-y-auto md:inset-0 z-modal">
    {#if isModalOpen}
        <div class="relative w-full max-w-7xl max-h-full"
             transition:scale={{duration: 700, easing: cubicInOut}}>
            <div class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <PlanForm planPoiCoordinates={planPoiCoordinates}
                          planPoi={planPoi}
                          planRide={planRide}
                          onDelete={onDelete}
                          onCreated={onCreated}
                          onModalClose={_handleModalClose}/>
            </div>
        </div>
    {/if}
</div>
